"use strict";
'use es6'; // This function is used so that we can stub the window object in tests

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindow = void 0;

var getWindow = function getWindow() {
  return window;
};

exports.getWindow = getWindow;